const specialCharacters = [' ', '!', '”', '#', '$', '%', '&', '’',
  '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']',
  '^', '_', '`', '{', '|', '}', '~'];

export default function isValidPasssword(password: string) {
  if (!password) {
    return false;
  }

  if (password.length < 8) {
    return false;
  }

  if (password.length > 64) {
    return false;
  }

  var specialCharacterExists = false;
  var lowercaseCharacterExists = false;
  var uppercaseCharacterExists = false;
  for (const char of password) {
    if (char >= 'a' && char <= 'z') {
      lowercaseCharacterExists = true;
    }  else if (char >= 'A' && char <= 'Z') {
      uppercaseCharacterExists = true;
    } else if (specialCharacters.includes(char)) {
      specialCharacterExists = true;
    }

    if (lowercaseCharacterExists && uppercaseCharacterExists && specialCharacterExists) {
      return true;
    }
  }

  return false;
}